export default __webpack_public_path__ + "static/media/Step 4.d9fb80fc.png";